import { action, mutatorAction } from 'satcheljs';
import { getSearchStore } from 'mini-3s-search-store/lib/store/Store';
import { SearchResultsTab } from 'mini-3s-search-store/lib/store/schema/SearchResultsTab';

/**
 * Action to start the search session
 */
export const start3sSearchSession = action('start3sSearchSession');

/**
 * Action to perform any common set up action for all query results
 * Eg: logging 3S results rendered signals etc.
 */
export const on3SSearchResultsFetchStart = action(
    'on3SSearchResultsFetchStart',
    (
        isDataCached: boolean,
        oldLogicalId: string,
        logResultsView?: (logicalId: string) => void,
        setLogicalId?: (logicalId: string) => void
    ) => ({
        isDataCached,
        oldLogicalId,
        logResultsView,
        setLogicalId,
    })
);

/**
 * Mutator action to set activeResultsTab in store
 */
export const setActiveResultsTab = mutatorAction(
    'setActiveResultsTab',
    (activeResultsTab: SearchResultsTab) => {
        getSearchStore().activeResultsTab = activeResultsTab;
    }
);

/**
 * Mutator action that sets the current results logicalId
 */
export const setSearchResultsLogicalId = mutatorAction(
    'setSearchResultsLogicalId',
    (logicalId: string) => {
        getSearchStore().searchResultsLogicalId = logicalId;
    }
);
